import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { usePopularDocuments } from '../../hooks/useDocuments';
import { usePageViewTracking } from '../../hooks/useTracking';

import DocumentsList from '../lists/DocumentsList';
import DocumentDescription from '../typography/DocumentDescription';
import DocumentTitle from '../typography/DocumentTitle';

import styles from '../../styles/pages/not-found-page.module.css';

type NotFoundPageProps = {
    current?: boolean;
    className?: string | null;
    contentClassName?: string | null;
};

function NotFoundPage({
    current = false,
    className = null,
    contentClassName = null,
}: NotFoundPageProps) {
    usePageViewTracking(current, {
        pageType: '404',
    });

    return (
        <div className={classNames([styles.container, className, contentClassName])}>
            <div className={styles.inner}>
                <DocumentTitle className={styles.title}>
                    <FormattedMessage
                        defaultMessage="Cette page n’existe pas"
                        description="Page title"
                    />
                </DocumentTitle>
                <DocumentDescription className={styles.description}>
                    <FormattedMessage
                        defaultMessage="Heureusement, nous en avons d’autres."
                        description="Page title"
                    />
                </DocumentDescription>

                <DocumentsList
                    // query={{
                    //     popular: 'week',
                    // }}
                    hook="popular"
                    presentation="layout"
                    layout="1_4_1_4"
                    count={10}
                    cardType="horizontal"
                    cardTheme="box-translucent"
                    cardWith={['brand-icon']}
                    className={styles.list}
                    itemsClassName={styles.items}
                />
            </div>
        </div>
    );
}

export default NotFoundPage;
